import React, { Component } from 'react';
import { Provider } from 'react-redux';

import Screens from 'screens/Screens';
import store from './store';


const clientId = document.getElementById('standings-app-root').getAttribute('data-clientId');
const sportId = document.getElementById('standings-app-root').getAttribute('data-sportId');
const productId = document.getElementById('standings-app-root').getAttribute('data-productId');
const adData = document.getElementById('standings-app-root').getAttribute('data-adData');

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Screens sportId={sportId} clientId={clientId} productId={productId} adData={adData} />
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx